import { Icon24KeyframeLinearLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const KeyframeIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M8 2a1 1 0 0 1 .708.293l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.415 0l-5-5a1 1 0 0 1 0-1.414l5-5 .074-.066A1 1 0 0 1 8 2M3 8l5 5 5-5-5-5z"
        fill="currentColor"
      />
    </svg>
  );
};

export const KeyframeIcon = fplIcon(KeyframeIconLocal, Icon24KeyframeLinearLarge);
